import { Button, Paper, Stack, Typography } from '@mui/material';

export interface TemplatePreviewProps {
  /** Already placeholder-substituted text, or `null` for the "sends nothing" state. */
  text: string | null;
  actions: { label: string }[];
  /** "Your text" / "Platform default (accepted)" / "Nothing — the bot stays silent". */
  caption: string;
}

/** A chat-bubble preview of what the bot will actually send (design §7.6). */
export function TemplatePreview({ text, actions, caption }: TemplatePreviewProps) {
  return (
    <Stack spacing={1} aria-live="polite" aria-label="Preview">
      <Typography variant="caption" color="text.secondary">
        {caption}
      </Typography>
      <Paper
        variant="outlined"
        sx={{ bgcolor: 'action.hover', borderRadius: 3, p: 1.5, maxWidth: 420 }}
      >
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }} color={text ? 'text.primary' : 'text.disabled'}>
          {text ?? '—'}
        </Typography>
        {actions.length > 0 ? (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
            {actions.map((action, index) => (
              <Button key={`${action.label}-${index}`} size="small" variant="outlined" disabled>
                {action.label}
              </Button>
            ))}
          </Stack>
        ) : null}
      </Paper>
    </Stack>
  );
}
